import { useStaticQuery, graphql } from "gatsby"
import { useMemo } from "react"

export const UseShopifyDataQuery = () => {
  const { allShopifyProduct } = useStaticQuery(graphql`
    {
      allShopifyProduct(sort: { title: ASC }) {
        edges {
          node {
            title
            metafields {
              namespace
              key
              value
              type
            }
            bundle {
              title
              productId
            }
            totalInventory
            tracksInventory
            tags
            options {
              name
              values
            }
            media {
              ... on ShopifyMediaImage {
                image {
                  originalSrc
                  altText
                }
              }
            }
            shopifyId
            legacyResourceId
            storefrontId
            descriptionHtml
            priceRangeV2 {
              maxVariantPrice {
                amount
              }
              minVariantPrice {
                amount
              }
            }
            createdAt
            handle
            sellingPlans {
              id
              name
              interval
              intervalCount
              price
            }
            variants {
              price
              inventoryQuantity
              compareAtPrice
              availableForSale
              shopifyId
              legacyResourceId
              storefrontId
              title
              selectedOptions {
                name
                value
              }
              sellingPlans {
                id
                name
                interval
                intervalCount
                price
              }
              media {
                ... on ShopifyMediaImage {
                  image {
                    originalSrc
                  }
                }
              }
              sku
            }
          }
        }
      }
    }
  `)

  return useMemo(() => allShopifyProduct.edges.map(({ node }) => node), [allShopifyProduct.edges])
}
